import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { fetchCorpSavedFilters } from "./Filters.slice";
import { filterPage, filterSliceInitialState, flagMap } from "./FiltersHelper";

const SLICE = "GlobalFilters";

export const fetchDefaultFilters = createAsyncThunk(`${SLICE}/fetchDefaultFilters`, async (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getFilters, {}, thunkApi, [], { types: data?.types })
);

export const FiltersSlice = createSlice({
  name: SLICE,
  initialState: filterSliceInitialState,
  reducers: {
    setPageFilter: (state, action) => {
      const { pageName, searchText, isFilterApplied, ...filters } = action.payload;
      const resultFlags = (action.payload?.modifiedFilter || [])
        .filter((item: any) => Array.isArray(item.options) && item.options.length === 0)
        .reduce((acc: any, item: any) => {
          Object.entries(flagMap).forEach(([flagName, keys]) => {
            if (keys.includes(item.key)) acc[flagName] = true;
          });
          return acc;
        }, {});
      return {
        ...state,
        [pageName]: {
          ...state[pageName],
          ...filters,
          dynamicSelectAll: resultFlags,
          isFilterApplied: isFilterApplied ? isFilterApplied : filters?.isFilterApplied ? true : false,
          searchText: searchText
        }
      };
    },

    resetPageModifiedFilter: (state, action) => {
      if (Array.isArray(action.payload.pageName)) {
        action.payload.pageName.map((key: any) => {
          state[key].modifiedFilter = [];
          state[key].searchText = "";
          state[key].isFilterApplied = false;
        });
      } else {
        return {
          ...state,
          [action.payload.pageName]: {
            ...state[action.payload.pageName],
            modifiedFilter: [],
            searchText: "",
            isFilterApplied: false
          }
        };
      }
    },
    resetAllModifiedFilters: (state) => {
      Object.keys(state).forEach((key) => {
        state[key].modifiedFilter = [];
        state[key].isFilterApplied = false;
        state[key].dynamicSelectAll = {
          selectAllProperties: false,
          selectAllManagementCompanies: false,
          selectAllOwnerGroup: false,
          selectAllPlans: false
        };
        state[key].searchText = "";
      });
    },
    resetAllFilters: (state) => {
      Object.keys(state).forEach((key) => {
        state[key].defaultFilter = [];
        state[key].modifiedFilter = [];
        state[key].isFilterApplied = false;
        state[key].dynamicSelectAll = {
          selectAllProperties: false,
          selectAllManagementCompanies: false,
          selectAllOwnerGroup: false,
          selectAllPlans: false
        };
        state[key].searchText = "";
      });
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefaultFilters.fulfilled, (state, action: any) => {
        // Loop through each key in the API response and update the Redux state dynamically
        const response = action.payload.other;
        return Object.keys(response).forEach((key) => {
          const filterData = response[key];
          if (state[key]) {
            // If the key already exists, update the defaultFilter and modifiedFilter dynamically
            state[key].defaultFilter = filterData[0].filters || [];
          } else {
            // Otherwise, initialize a new entry with defaultFilter and modifiedFilter
            state[key] = {
              defaultFilter: filterData[0].filters || [],
              modifiedFilter: []
            };
          }
        });
      })
      .addCase(fetchCorpSavedFilters.fulfilled, (state, action: any) => {
        const response = action.payload?.default;
        state[filterPage.dashboardDisplay] = {
          defaultFilter: response?.[0]?.filters || [],
          modifiedFilter: []
        };
      });
  }
});

export const { setPageFilter, resetPageModifiedFilter, resetAllModifiedFilters, resetAllFilters } =
  FiltersSlice.actions;

export default FiltersSlice.reducer;
